import {calculatorFinancialApplicationFieldOptions} from "../constants/calculator_financial_application_field_labels";

const fieldLabelByKey = new Map<string, string>(calculatorFinancialApplicationFieldOptions.map((option) => [option.value, option.label]));

const fieldSortIndexByKey = new Map<string, number>(calculatorFinancialApplicationFieldOptions.map((option, index) => [option.value, index]));

export function getCalculatorFinancialApplicationFieldLabel(fieldKey: string): string {
    return fieldLabelByKey.get(fieldKey) ?? fieldKey;
}

export function getCalculatorFinancialApplicationFieldSortIndex(fieldKey: string): number {
    return fieldSortIndexByKey.get(fieldKey) ?? Number.MAX_SAFE_INTEGER;
}
import {calculatorFinancialApplicationFieldOptions} from "../constants/calculator_financial_application_field_labels";

const fieldLabelByKey = new Map<string, string>(calculatorFinancialApplicationFieldOptions.map((option) => [option.value, option.label]));

const fieldSortIndexByKey = new Map<string, number>(calculatorFinancialApplicationFieldOptions.map((option, index) => [option.value, index]));

export function getCalculatorFinancialApplicationFieldLabel(fieldKey: string): string {
    return fieldLabelByKey.get(fieldKey) ?? fieldKey;
}

export function getCalculatorFinancialApplicationFieldSortIndex(fieldKey: string): number {
    return fieldSortIndexByKey.get(fieldKey) ?? Number.MAX_SAFE_INTEGER;
}
